export default __webpack_public_path__ + "static/media/gluten.fddf28b7.svg";